import { TableSearch } from "./types";

export const initialTableSearchState: TableSearch = {
  query: "",
  sort: "",
  order: "",
  isFilterSearchLoading: false,
  wildcardQuery: "",
  isKeywordInputFocus: false,
};
